export default __webpack_public_path__ + "static/media/Brow_5_C4.a9b2f12d.svg";